module.exports = __webpack_public_path__ + "img/scanner.df314f3e.svg";